<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container-fluid p-0">
      <!-- login page start-->
      <div class="authentication-main">
          <div class="row">
              <div class="col-md-12">
                  <div class="auth-innerright">
                      <div class="authentication-box">
                          <div class="text-center"><img alt="" src="../assets/images/logo-dark.png" width="150"></div>
                          <div class="card mt-4">
                              <div class="card-body">
                                  <div class="text-center text-uppercase">
                                      <h4>LOGIN</h4>
                                  </div>
                                  <form class="theme-form" @submit.prevent="handleSubmit">
                                      <div class="form-group">
                                          <label for="email" class="col-form-label">Email</label>
                                          <input type="email" v-model="user.email" id="email" name="email"
                                                  class="form-control"
                                                  :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                                          <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                                              <span v-if="!$v.user.email.required">Email is required</span>
                                              <span v-if="!$v.user.email.email">Email is invalid</span>
                                          </div>
                                      </div>
                                      <div class="form-group">
                                          <label for="password" class="col-form-label">Password</label>
                                          <input type="password" v-model="user.password" id="password"
                                                  name="password" class="form-control"
                                                  :class="{ 'is-invalid': submitted && $v.user.password.$error }"/>
                                          <div v-if="submitted && $v.user.password.$error"
                                                class="invalid-feedback">
                                              <span v-if="!$v.user.password.required">Password is required</span>
                                              <span v-if="!$v.user.password.minLength">Password must be at least 6 characters</span>
                                          </div>
                                      </div>
                                      <div class="checkbox p-0">
                                          <input id="checkbox1" type="checkbox">
                                          <label for="checkbox1">Remember me</label>
                                      </div>
                                      <div class="form-group form-row mt-3 mb-0 loading-wrapper">
                                          <div class="btn-loading" v-if="loading">
                                              <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                          </div>
                                          <button class="btn btn-primary btn-block">Login</button>
                                      </div>
                                      <router-link class="mt-3 d-inline-block" to="/auth/forgot-password">Forgot Password?</router-link>
                                      <hr class="hr-text" data-content="OR">
                                      <div class="form-group form-row mt-3 mb-0 row">
                                          <router-link to="/auth/register" tag="button"
                                                class="btn btn-secondary btn-block">Sign Up
                                          </router-link>
                                      </div>
                                    <div class="form-group form-row mt-3 mb-0">
                                    </div>
                                  </form>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <b-modal ref="modal-advisor" title="Content Creator" hide-footer no-close-on-backdrop>
      <p class="modal-text">
        Please register as a content creator before logging in. Learn about being a content creator by visiting <a href="https://startontrac.com/content-creator" target="_blank">Content Creators</a>
      </p>
    </b-modal>
  </div>
</template>

<script>
  import Userauth from '../auth/js/index';
  import {required, email, minLength} from "vuelidate/lib/validators";
  import zapier from "../services/zapier";

  export default {
    name: 'login',
    data() {
      return {
        user: {
          email: "",
          password: "",
          tokenProvider: 'Dashboard'
        },
        submitted: false,
        loading: false
      }
    },
    validations: {
      user: {
        email: {required, email},
        password: {required, minLength: minLength(6)},
      }
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        let user = {
          email: this.user.email,
          password: this.user.password,
          tokenProvider: this.user.tokenProvider
        };

        this.loading = true;
        this.$store.dispatch('loginUser', user)
        .then(async (val) => {
          if (val.data.statusCode === 200) {
            localStorage.setItem('token', val.data.result.token);
            localStorage.setItem('userId', val.data.result.userId);
            localStorage.setItem('enteredTime', Date.now());
            if (val.isFirstTime) {
              await zapier.firstLogin(val);
            }
            this.$store.dispatch('getUser', val.token).then(() => {
              this.loading = false;
              this.$router.push('/')
            });
          }
          else {
            if (val.data.result == 'NOTALLOWED') {
              this.$refs['modal-advisor'].show();
            }
            else {
              this.$toasted.show(val.data.result, {
                theme: 'bubble',
                position: "bottom-right",
                type: 'error',
                duration: 4000
              });
            }
          }

          this.loading = false;
        }).catch(() => {
          this.$toasted.show('Incorrect login or password', {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 3000
          });
          this.loading = false;
        });
      },

      login() {
        Userauth.login()
      }
    }
  }
</script>
<style scoped>
  .page-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  .authentication-main .auth-innerright {
    min-height: auto;
  }
  .authentication-main {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-text {
    font-size: 1rem;
    color: #535353;
  }
</style>
